import { useEffect, useState } from 'react';
import { fetchManifestLegPax } from '../api/manifests';

type Props = {
  manifestNo: string;
  manifestLegNumber: number | null;
};

const useFetchManifestLegPax = ({ manifestNo, manifestLegNumber }: Props) => {
  const [data, setData] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!manifestLegNumber) {
          return;
        }
        setIsLoading(true);
        const response = await fetchManifestLegPax(
          manifestNo,
          manifestLegNumber
        );
        const modifiedData = response.data?.content || [];
        setData(modifiedData);
        setIsError(false);
        setError(null);
      } catch (err) {
        setIsError(true);
        setError('Error fetching data');
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [manifestNo, manifestLegNumber]);

  return { data, isLoading, isError, error };
};

export default useFetchManifestLegPax;
